import { Skeleton } from '@mui/material';
import { Suspense, lazy } from 'react';

import ModalButton from '@/Components/inputs/ModalButton';

import { faRectangleList } from '@fortawesome/free-regular-svg-icons/faRectangleList';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const EmailSharingLazy = lazy(() => import(/* webpackChunkName: "components/email-sharing/body" */ './Body'));
const EmailSharingBody = () => {
  return (
    <Suspense fallback={<Skeleton variant="rectangular" sx={{ width: '100%' }} height={200} />}>
      <EmailSharingLazy />
    </Suspense>
  );
};

type WrapperProps = {
  buttonClassName?: string;
  isFallback?: boolean;
  disabled?: boolean;
  buttonProps?: React.HTMLAttributes<HTMLButtonElement>;
};

export const FrontendEmailSharing = (props: WrapperProps) => {
  return (
    <ModalButton
      button={
        <button
          type="button"
          className={`email ${props?.buttonClassName ?? ''}`}
          aria-label="Email Sharing"
          disabled={props?.isFallback || props?.disabled}
          {...props?.buttonProps}
        >
          <FontAwesomeIcon icon={faRectangleList} />
        </button>
      }
    >
      <EmailSharingBody />
    </ModalButton>
  );
};
